<template>
  <el-cascader :options="options" v-model="selectedOptions" @change="handleChange"></el-cascader>
</template>
<script>
export default {
  name: 'areaSelect',
  props: {
    depCode: {
      type: String
    }
  },
  data() {
    return {
      selectedOptions: [],
      childRepDepConfigs: [],
      params: { depCode: '330402000000' }
    };
  },
  computed: {
    options() {
      return this.$utils.transforTree(this.childRepDepConfigs);
    }
  },
  methods: {
    handleChange() {
      this.$emit('areaSelect', this.selectedOptions);
    },
    async getListAllChildDepTree() {
      const { bean } = await this.$services.post({
        type: 'DEPT',
        url: 'getListAllChildDepTree',
        params: {
          depCode: 330300000000
        }
      });
      this.childRepDepConfigs = bean.childRepDepConfigs;
    },
    async getrepDepConfigControllerListAllChildDep() {
      // let res = await this.$services.post({
      //   type: 'DATAMANAGE_COMMON',
      //   url: 'getrepDepConfigControllerListAllChildDep',
      //   params: this.params
      // });

    }
  },
  created() {
    this.getrepDepConfigControllerListAllChildDep();
  }
};
</script>
<style lang="scss" scoped>
</style>
